import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const PlusMinusWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTypographyTitle = styled(Typography)``;

export const PlusMinusInput = styled.div`
  display: flex;
  height: 2.5rem;
  flex: 1;
  font-weight: 500;
`;

export const PlusMinusValue = styled.div`
  border-top: 1px solid ${props => props.theme.palette.grey[400]};
  background-color: #fff;
  border-bottom: 1px solid ${props => props.theme.palette.grey[400]};
  display: flex;
  height: 2.5rem;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
`;

export const StyledButton = styled(Button)`
  min-width: 2.5rem;
  max-width: 2.5rem;
  height: 100%;
  color: ${props => props.theme.palette.secondary.main};
  border: 1px solid ${props => props.theme.palette.grey[400]};
  background-color: ${props => props.theme.palette.grey[50]};
  border-radius: 5px;
`;

export const MinusButton = styled(StyledButton)`
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 2.5rem;
`;

export const PlusButton = styled(StyledButton)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 2.5rem;
`;
